import * as React from 'react';

function SvgLogoFacebookOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M22 12c0-5.522-4.478-10-10-10S2 6.478 2 12c0 4.991 3.656 9.128 8.438 9.879v-6.988h-2.54V12h2.54V9.797c0-2.506 1.493-3.891 3.777-3.891 1.094 0 2.239.195 2.239.195v2.462h-1.262c-1.242 0-1.63.77-1.63 1.562V12h2.773l-.443 2.892h-2.33v6.988C18.345 21.13 22 16.992 22 12z", clipRule: "evenodd" })));
}

export default SvgLogoFacebookOutline;
